
import MapboxDraw from '@mapbox/mapbox-gl-draw';
class measureTool {

  constructor() {
    this.drawAdded = false;/*是否已经初始化过*/
    this.map = "";/*地图实例*/
    this.draw = "";/*绘图插件实例*/
    this.curclickCallBackFunc = "";/*测量完成回调*/
    this.curUpdateCallBackFunc = "";/*测量更新回调*/
  }
  /*添加绘图工具实例*/
  addDraw(){
    try{
      this.draw = new MapboxDraw({displayControlsDefault: false, controls: {}});
      this.map.addControl(this.draw);
    }catch(err){
      this.draw = "";
      console.error("初始化测量工具失败");
    }

  };

  /*初始化实例*/
  init(map){
    if(!map){return "请传入地图实例"}
    if(this.draw){ console.error("测量工具已经初始化过,不能二次初始化") ;return; }
    this.map = map;
    this.addDraw();
  }

  /*
  * 开始测量
  * @params type 测量类型 三种(draw_point,draw_line_string,draw_polygon)(点线面)
  *  @params clickCallBackFunc 测量完成回调函数
  *  @params updateCallBackFunc

  */
  measure(type,clickCallBackFunc = "",updateCallBackFunc = ""){
    if(!this.draw){ console.error("请先初始化测量工具");return;}
    this.map.getCanvas().style.cursor='crosshair';/*修改鼠标指针样式*/
    if(clickCallBackFunc){
      this.curclickCallBackFunc = clickCallBackFunc;
      this.map.on('draw.create',this.handleClickCallBack);
    }

    if(updateCallBackFunc){
      this.curUpdateCallBackFunc = updateCallBackFunc;
      this.map.on('draw.update',this.handleUpdatekCallBack);
    }
    this.map.getCanvas().addEventListener('click', this.handleCanvasClick);
    document.addEventListener('keyup',this.handleEsc);
    this.draw.changeMode(type);
  }

  /*地图点击事件*/
   handleCanvasClick(e){
    e.stopPropagation();/*阻止事件冒泡,保证重复检查的功能独占鼠标点击事件*/
  }

  /*处理esc按钮*/
  handleEsc(e){
    /*如果点击了esc,则移除canvas的监听事件*/
    if (e.keyCode == 27) {
      this.unbindEvent();
    }
  }

  /*获取测量插件实例用于自己扩展*/
  getDraw(){
    return this.draw;
  }

  /*解绑相关事件*/
  unbindEvent(){
    if(this.map){this.map.getCanvas().style.cursor='';}
    document.removeEventListener('keyup',this.handleEsc);
    setTimeout(() => {
      this.map.getCanvas().removeEventListener('click',this.handleCanvasClick);
    },200);
  }

   handleClickCallBack(e){
    this.unbindEvent();
    if(this.curclickCallBackFunc){
      this.curclickCallBackFunc(e);
      this.curclickCallBackFunc = "";
    }
  }

   handleUpdatekCallBack(e){
    this.unbindEvent();
    if(this.curUpdateCallBackFunc){
      this.curUpdateCallBackFunc(e);
      this.curUpdateCallBackFunc = "";
    }
  }


  /*清除所有绘画*/
  clear(){
    if(this.draw){this.draw.deleteAll();}
  }

}

export default measureTool



// WEBPACK FOOTER //
// ./src/components/mapElementBox/toolbar/measureComponent/measureTool.js